<template>
  <section
    v-if="items.length"
    class="relative z-2 -mt-8 rounded-t-[40px] bg-white pt-20 pb-20 md:pt-30 md:pb-10"
  >
    <DefaultGrid class="gap-y-12 md:gap-y-16">
      <div class="col-span-full mb-8 text-center">
        <h2
          class="type-font-salt-ss02 text-[80px] leading-[0.9] font-medium tracking-[-0.03em]"
        >
          <HomeHighlight src="/images/pink-text-highlight.svg" :rotate="-3.18"
            >Good</HomeHighlight
          >
          question!
        </h2>
      </div>
      <div
        class="col-span-full space-y-3 lg:col-span-8 lg:col-start-3 2xl:col-span-6 2xl:col-start-4"
      >
        <HomeFaqItem
          v-for="(item, idx) in items"
          :key="item.id"
          :question="item.question"
          :answer="item.answer"
          :index="idx"
          section="good_questions"
        />
      </div>
    </DefaultGrid>
  </section>
</template>

<script setup lang="ts">
import type { PaginatedDocs } from 'payload'
import type { GoodQuestion } from '#payload-types'

import { GetGoodQuestionsDocument } from '#graphql-exports'

interface GoodQuestionsQueryResult {
  GoodQuestions: PaginatedDocs<GoodQuestion>
}

// Fetched here rather than passed in, since the section renders on both the
// home page and school pages and shares one list across them.
const { data } = await useAsyncQuery<GoodQuestionsQueryResult>(
  GetGoodQuestionsDocument,
  { limit: 100 },
)

const items = computed(() => data.value?.GoodQuestions.docs ?? [])
</script>
